import React, { useEffect, useState } from "react";
import { LazyIcon } from "../LazyIcon/LazyIcon";
import Icon from "@mdi/react";
import { mdiReceiptTextOutline, mdiReceiptTextPlusOutline } from "@mdi/js";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { ProjectApi } from "../../system/api/ProjectApi";
import { project } from "../../system/types/project/project";
import { useTranslations } from "../../hooks/useTranslations";

import "./Menu.scss";

const Menu = () => {

    const { t } = useTranslations();

    const navigate = useNavigate();


    const [sessionToken, setSessionToken] = useState<string>('');
    const [sessionEmail, setSessionEmail] = useState<string>('');

    const [projectList, setProjectList] = useState<project[]>([]);


    const [visible, setVisible] = useState<boolean>(false);
    const [iconName, setIconName] = useState<string>('mdiMenu');


    useSelector((state: RootState) => {

        if (state.activeUser.activeUserToken !== sessionToken) {
            setSessionToken(state.activeUser.activeUserToken);
        }

        if (state.activeUser.activeUserEmail !== sessionEmail) {
            setSessionEmail(state.activeUser.activeUserEmail);
        }
    });

    const loadList = async () => {
        const api = new ProjectApi(sessionToken, sessionEmail);
        const result = await api.getListProjects();
        setProjectList(result);
    }

    const gotToProject = (id: string) => {
        setVisible(false);
        navigate('/projects/' + id);
    }

    useEffect(() => {
        if (sessionEmail === '') {
            return;
        }
        loadList();
    }, [sessionEmail]);



    const toggleMenu = () => {
        setVisible(!visible);
    };

    const newProject = () => {
        setVisible(false);
        navigate('/projects/0');
    }

    useEffect(() => {
        setIconName(visible ? 'mdiClose' : 'mdiMenu');
    }, [visible]);

    return (
        <>
            <div className="menu">
                <span className="menu" onClick={toggleMenu}><LazyIcon icon={iconName} size={1}></LazyIcon></span>
            </div>
            {visible ?
                <div className="menuList">
                    <ul>
                        <li>
                            <span className="mnuEntry active" onClick={() => {
                                            gotToProject('');
                                        }}><Icon path={mdiReceiptTextOutline} size={1} />{t('projects.projects')}</span>
                            <ul>
                                <li>
                                    <span className="mnuEntry active"
                                        onClick={newProject}
                                    ><Icon path={mdiReceiptTextPlusOutline} size={1} />{t('projects.newproject')}</span>
                                </li>
                                {projectList.map((project) => (
                                    <li key={project._id}>
                                        <span className="mnuEntry active" onClick={() => {
                                            gotToProject(project._id);
                                        }}><Icon path={mdiReceiptTextOutline} size={1} /><strong>{project.name}</strong> - {project.baseLanguage.name}</span>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    </ul>
                </div>
                : null}
        </>
    );
};

export { Menu };
